import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  // Available languages based on locale files
  availableLanguages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch (German)', flag: '🇩🇪' },
    { code: 'ro', name: 'Română (Romanian)', flag: '🇷🇴' }
  ];

  constructor() {}

  /**
   * Check if language features should be enabled (only in production/deployment)
   */
  isLanguageFeatureEnabled(): boolean {
    // Only enable language features in production or when not running on localhost
    return environment.production || !this.isLocalhost();
  }

  /**
   * Check if running on localhost
   */
  private isLocalhost(): boolean {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';
  }

  getCurrentLang() {
    const storedLang = localStorage.getItem('preferredLanguage');
    return storedLang && this.isValidLanguage(storedLang) ? storedLang : 'en';
  }

  isValidLanguage(lang: string): boolean {
    return ['en', 'de', 'ro'].includes(lang);
  }

  setLanguage(lang: string): void {
    if (this.isValidLanguage(lang)) {
      localStorage.setItem('preferredLanguage', lang);
    }
  }

  getAvailableLanguages() {
    return this.availableLanguages;
  }
}
